<template></template>

<script>
// 引入API
import { loginS2S, getAuthCode, getSessionId } from "../../api/HttpService";
export default {
  data: function () {
    return {
      channelCode: null,
      chlAppId: null,
      apiPath: null,
      userInputs: null,
    };
  },
  methods: {},
  mounted: async function () {
    this.channelCode = this.$route.query.channelCode;
    let clientTypeFromBiz = this.$route.query.clientTypeFromBiz;
    let clientTypeFromContainer = this.$route.query.clientTypeFromContainer;
    let channelCodeFromBiz = this.$route.query.channelCode;
    let channelCodeFromContainer = this.$route.query.channelCodeFromContainer;
    if (this.$route.query.userInputs) {
      this.userInputs = decodeURIComponent(this.$route.query.userInputs);
    }
    console.log(
      clientTypeFromBiz,
      channelCodeFromBiz,
      clientTypeFromContainer,
      channelCodeFromContainer
    );
    // 如果没拿到容器侧的code
    if (!clientTypeFromContainer || !channelCodeFromContainer) {
      this.$router.replace({
        name: "ChannelErrorPage",
        query: {
          client: clientTypeFromBiz,
          channel: channelCodeFromBiz,
        },
      });
      return;
    }
    // 容器客户端和业务所要求的客户端不一致(app wechat)
    if (clientTypeFromBiz != clientTypeFromContainer) {
      this.$router.replace({
        name: "ChannelErrorPage",
        query: {
          client: clientTypeFromBiz,
          channel: channelCodeFromBiz,
        },
      });
      return;
    }
    // 容器渠道和业务要求的渠道不一致(dxlc  cxnt)
    if (channelCodeFromBiz != channelCodeFromContainer) {
      this.$router.replace({
        name: "ChannelErrorPage",
        query: {
          client: clientTypeFromBiz,
          channel: channelCodeFromBiz,
        },
      });
      return;
    }

    window.localStorage.setItem("clientType_AI", "wechat");
    window.localStorage.setItem("channelCode_AI", this.channelCode);
    //记录渠道为亮啦wechat
    window.localStorage.setItem("channel_App", "wechat");
    // 计算apiPath
    switch (this.channelCode) {
      case "dxlc":
        this.chlAppId = "com.brightcns.dxlc.wxmp";
        this.apiPath = "./liuzhouGateway";
        break;
      case "cxnt":
        this.chlAppId = "com.brightcns.cxnt.wxmp";
        this.apiPath = "./nantongGateway";
        break;
      case "pinba":
        this.chlAppId = "cstmbus.user.wxmp";
        this.apiPath = "./pinbaGateway";
        break;
      case "linkfashion":
        this.chlAppId = "com.brightcns.flzt.wxmp";
        this.apiPath = "./fuzhuangGateway";
        break;
    }
    console.log(this.$route.query);
    // 未登录时 无sessionId 跳转首页
    if (!this.$route.query.sessionId) {
      window.localStorage.removeItem("sessionId");
      //   异常情况  地址栏中没有sessionId
      return;
    }
    if (this.$route.query.sessionId) {
      window.localStorage.removeItem("sessionId");
      window.localStorage.removeItem("sessionId_AI");
      let params = {
        chlAppId: this.chlAppId,
        chlSid: this.$route.query.sessionId,
      };
      await loginS2S(
        params,
        this.apiPath,
        this.channelCode == "pinba" ? "cstmbus.user.h5" : null
      )
        .then(({ res }) => {
          console.log(res);
          if (
            res.originalData.bizCode == "SUCCESS" &&
            res.originalData.code == "SUCCESS"
          ) {
            window.localStorage.setItem("sessionId", res.data.sessionId);
            // 拿到了第一个sessionId
            // 拿着这个sessionId去换authCode
            getAuthCode(
              {
                newFlag: true,
              },
              this.apiPath,
              this.channelCode == "pinba" ? "cstmbus.user.h5" : null
            )
              .then(({ res }) => {
                console.log(res);
                if (res.code == "SUCCESS") {
                  // 拿到authCode
                  // 再去换sessionId
                  getSessionId({
                    authCode: res.data,
                    system: this.channelCode,
                  })
                    .then(({ res }) => {
                      console.log(res);
                      if (res.code == "SUCCESS") {
                        // 拿到了最终的sessionId
                        window.localStorage.setItem(
                          "sessionId_AI",
                          res.originalData.data.sessionId
                        );
                        window.localStorage.setItem(
                          "appId_AI",
                          res.originalData.data.appId
                        );
                        window.localStorage.setItem(
                          "userId_AI",
                          res.originalData.data.userId
                        );
                        const thisUserId = res.originalData.data.userId;
                        window._czc &&
                          window._czc.push(["_setUUid", thisUserId]);
                        // 如果此时地址栏中存在ai_app_code
                        // 那么跳到列表后，要直接加载该智能体
                        if (this.$route.query.ai_app_code) {
                          console.log(
                            "地址栏中存在ai_app_code",
                            this.$route.query.ai_app_code
                          );
                          this.$router.replace({
                            name: "ChatListPage",
                            params: {
                              autoJumpToAgent: this.$route.query.ai_app_code,
                              userInputs: this.userInputs || null,
                            },
                          });
                        }
                        // 跳到发现页
                        else if (this.$route.query.jumpFind) {
                          this.$router.replace({
                            name: "ChatListPage",
                            params: {
                              jumpFind: true,
                            },
                          });
                        } else {
                          this.$router.replace({
                            name: "ChatListPage",
                          });
                        }
                      }
                    })
                    .catch((err) => {});
                }
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>

<style></style>
